import React, { type ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<'p'>;

export default function P(props: Props) {
  return <p className="govuk-body" {...props} />;
}
